import React, { useEffect, useState } from 'react';
import GenericNavBar from 'newComponents/GenericNavBar';

import { useTour } from 'hooks/useTour';
import { Container } from 'pages/Profile/styles';
import {
  PageHeader,
  TitleBlock,
  Title,
  Subtitle,
  FilterBar,
  FilterLabel,
  SwitchButton,
  SwitchTrack,
  SwitchKnob,
} from './styles';
import Contract from 'pages/Profile/Contract';
import Addendum from 'pages/Profile/Addendum';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';

const MeusContratos: React.FC = () => {
  const [showAdendos, setShowAdendos] = useState(false);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('profile');
    setSteps(2);
  }, [setTourType, setSteps]);

  useEffect(() => {
    if (showTour && tourType === 'profile' && tourStep < 2) {
      const el = document.getElementById('user-menu');
      if (el) {
        el.scrollIntoView();
      }
    }
  }, [showTour, tourType, tourStep]);

  return (
    <GenericNavBar
      breadcrump="› Meus contratos"
      selected="meus-contratos"
      intro={() => true}
    >
      <Container>
        <PageHeader>
          <TitleBlock>
            <Title>Meus contratos</Title>
            <Subtitle>Visualize seus contratos e busque por adendos.</Subtitle>
          </TitleBlock>
          <FilterBar>
            <FilterLabel id="meus-contratos-filter-label">
              Contratos com adendos
            </FilterLabel>
            <SwitchButton
              role="switch"
              aria-checked={showAdendos}
              aria-labelledby="meus-contratos-filter-label"
              onClick={() => setShowAdendos((prev) => !prev)}
            >
              <SwitchTrack $active={showAdendos}>
                <SwitchKnob $active={showAdendos} />
              </SwitchTrack>
            </SwitchButton>
          </FilterBar>
        </PageHeader>
        {!showAdendos && (
          <TableWrap
            showTour={
              showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              !showAdendos
            }
          >
            <Contract />
            {showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              !showAdendos && (
                <TourBalloon
                  title="Contratos"
                  content="Aqui você encontra os contratos atrelados a sua conta."
                  position={{
                    left: '30%',
                    right: '0',
                    top: '-190px',
                    arrowPosition: 'bottom',
                    maxWidth: 'unset',
                    width: '300px',
                    boxShadow: false,
                  }}
                />
              )}
          </TableWrap>
        )}
        {showAdendos && (
          <TableWrap
            showTour={
              showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              showAdendos
            }
          >
            <Addendum />
            {showTour &&
              tourType === 'profile' &&
              tourStep === 2 &&
              showAdendos && (
                <TourBalloon
                  title="Adendos"
                  content="Aqui você encontra os adendos atrelados a sua conta."
                  position={{
                    left: '30%',
                    right: '0',
                    top: '-190px',
                    arrowPosition: 'bottom',
                    maxWidth: 'unset',
                    width: '300px',
                    boxShadow: false,
                  }}
                />
              )}
          </TableWrap>
        )}
      </Container>
    </GenericNavBar>
  );
};

export default MeusContratos;
